import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { NeuInput } from "../../components/neu/Neu";
import { checkDuplicate } from "../../api/masterItems";
import { Field } from "./ItemFormParts";
import { localName } from "../../lib/localName";

// حقل الاسم مع فحص التكرار الفوري: تطابق دقيق يمنع الحفظ، والمشابه يُعرض تحذيراً.
export const ItemNameField = ({ form, setForm, branchId, excludeId, onDuplicate }) => {
  const { t } = useTranslation();
  const [result, setResult] = useState(null);

  useEffect(() => {
    const name = (form.name_ar || "").trim();
    if (name.length < 2) { setResult(null); onDuplicate?.(null); return undefined; }
    const id = setTimeout(() => {
      checkDuplicate(name, branchId, excludeId).then((data) => { setResult(data); onDuplicate?.(data); })
        .catch(() => setResult(null));
    }, 300);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.name_ar, branchId, excludeId]);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });
  const exact = result?.exact;
  const similar = result?.similar || [];

  return (
    <>
      <Field label={t("purchases.items.nameAr")} required>
        <NeuInput data-testid="item-name_ar" value={form.name_ar || ""} onChange={set("name_ar")}
                  placeholder={t("purchases.items.namePlaceholder")} />
        {exact ? (
          <span data-testid="item-duplicate-exact"
                className="flex items-center gap-1.5 rounded-xl bg-rose-500/10 px-3 py-2 text-[11px] font-bold text-rose-600">
            <AlertTriangle className="h-3.5 w-3.5" />
            {t("purchases.items.duplicateExact", { code: exact.item_code })}
          </span>
        ) : null}
        {!exact && similar.length ? (
          <div data-testid="item-duplicate-similar" className="grid gap-1 rounded-xl bg-amber-500/10 px-3 py-2">
            <span className="text-[11px] font-bold text-amber-600">{t("purchases.items.duplicateSimilar")}</span>
            {similar.map((row) => (
              <span key={row.item_id} className="text-[11px] text-muted-foreground">
                <span className="num font-mono">{row.item_code}</span> · {localName(row)}{row.brand ? ` — ${row.brand}` : ""}
              </span>
            ))}
          </div>
        ) : null}
        {result && !exact && !similar.length ? (
          <span data-testid="item-duplicate-ok" className="flex items-center gap-1 text-[11px] font-bold text-emerald-600">
            <CheckCircle2 className="h-3.5 w-3.5" /> {t("purchases.items.nameUnique")}
          </span>
        ) : null}
      </Field>
      <Field label={t("purchases.items.nameEn")}>
        <NeuInput data-testid="item-name_en" dir="ltr" value={form.name_en || ""} onChange={set("name_en")} />
      </Field>
    </>
  );
};
